import React, {Component} from "react";

export class GSCLogo extends Component {
    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    render() {
        const containerStyle = {
            display: 'inline-block',
            marginLeft: this.getHSpace(),
            marginRight: this.getHSpace(),
            marginTop: this.getVSpace(),
            marginBottom: this.getVSpace(),
            ...this.props.styles
        };
        return (
            <span style={containerStyle} aria-label="Google Search Console">
                <svg xmlns="http://www.w3.org/2000/svg" width={this.getWidth()} height={this.getHeight()} viewBox="0 0 24 24" fill="none">
                    <path d="M10.5 3a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11z" fill="#4285F4"/>
                    <path d="M15.8 15.8a1 1 0 0 1 1.4 0l3.5 3.5a1 1 0 0 1-1.4 1.4l-3.5-3.5a1 1 0 0 1 0-1.4z" fill="#4285F4"/>
                </svg>
            </span>
        );
    }
}
